var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.751 3.519a1.445 1.445 0 0 1 2.55.1l1.982 4.072 4.427.658.11.02c1.081.241 1.487 1.569.77 2.388l-.075.08-3.21 3.172.759 4.483.014.109c.105 1.084-.997 1.932-2.02 1.477l-.102-.05L12 17.917l-3.956 2.111c-1.084.579-2.305-.365-2.107-1.536l.756-4.483-3.208-3.172c-.844-.836-.395-2.31.805-2.488l4.426-.658 1.982-4.073z"
})));
export default SvgStarSolid;